import React from 'react';
import { Row, Col } from 'antd';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import './styles.css';

import { useState } from 'react';
export const ProductItem = ({ item, onIncrease, onDecrease, disabled }) => {
  const { name, quantity, max_quantity, price, description, image } = item;
  const [infoVisible, setInfoVisible] = useState(false);
  return (
    <>
      <Col span={24} xl={12} className='h-full'>
        <Row
          justify='space-between'
          className='center reservation-booking-addon-container gap-05r h-full'
        >
          <Row className=' center detail'>
            {image ? (
              <img
                height={70}
                width={110}
                className='br10 mg-right-10'
                style={{
                  objectFit: 'cover',
                  minWidth: '110px',
                  height: '70px',
                }}
                src={image}
                alt='product-add-on-icon'
              />
            ) : (
              <div
                className='product-add-on-no-image gSemiBold fs-12'
                style={{ minWidth: '110px', height: '70px' }}
              >
                No Image
              </div>
            )}
            <div
              className=' mg-right-10'
              // style={{ borderRight: '1px solid #BBBBBB' }}
            >
              <div className='fs-14 gSemiBold sb-blue-900'>{name}</div>
              <div className='fs-14 gRegular sb-blue-900'>
                {item?.currency ? item?.currency : 'THB'}
                {item?.convertedAmount
                  ? item?.convertedAmount.toFixed(2)
                  : price.toFixed(2)}
              </div>
            </div>
          </Row>
          <div
            className='pd-left-10  center justify-center quantity'
            // style={{ borderLeft: '1px solid #BBBBBB' }}
          >
            <Row
              className='center flex-nowrap'
              gutter={[16, 15]}
              style={{ alignItems: 'normal' }}
            >
              <Col className='center cp'>
                <button
                  onClick={onDecrease}
                  className='icon-button'
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                  }}
                  type='button'
                  disabled={quantity <= 0 || disabled}
                >
                  <MinusCircleOutlined
                    width={16}
                    height={16}
                    style={{
                      color: quantity <= 0 || disabled ? '#CCD3D9' : '#5C6166',
                    }}
                  />
                </button>
              </Col>

              <div className='gRegular row-center'>{quantity}</div>
              <Col className='center cp'>
                <button
                  onClick={onIncrease}
                  className='icon-button'
                  style={{
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                  }}
                  type='button'
                  disabled={
                    (max_quantity && quantity >= max_quantity) || disabled
                  }
                >
                  <PlusCircleOutlined
                    width={16}
                    height={16}
                    style={{
                      color:
                        max_quantity || disabled
                          ? quantity >= max_quantity || disabled
                            ? '#CCD3D9'
                            : '#5C6166'
                          : '#5C6166',
                    }}
                  />
                </button>
              </Col>
            </Row>
          </div>
        </Row>
      </Col>
    </>
  );
};
